module.exports = __webpack_public_path__ + "img/Edelstahlbalkonbruestung.fbbd188c.webp";